export const STATE_TAX_BUDGET_REQUEST="STATE_TAX_BUDGET_REQUEST"
export const STATE_TAX_BUDGET_SUCCESS="STATE_TAX_BUDGET_SUCCESS"
export const STATE_TAX_BUDGET_FAILURE="STATE_TAX_BUDGET_FAILURE"

export const STATE_JOBS_REQUEST="STATE_JOBS_REQUEST"
export const STATE_JOBS_SUCCESS="STATE_JOBS_SUCCESS"
export const STATE_JOBS_FAILURE="STATE_JOBS_FAILURE"